var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10C16.9853 10 19 7.98528 19 5.5C19 3.01472 16.9853 1 14.5 1C12.0147 1 10 3.01472 10 5.5C10 7.98528 12.0147 10 14.5 10ZM16.5 4V5.79289L16.8536 6.14645C16.9966 6.28945 17.0393 6.5045 16.962 6.69134C16.8846 6.87818 16.7022 7 16.5 7H12.5C12.2978 7 12.1155 6.87818 12.0381 6.69134C11.9607 6.5045 12.0035 6.28945 12.1465 6.14645L12.5 5.79289V4C12.5 2.89543 13.3954 2 14.5 2C15.6046 2 16.5 2.89543 16.5 4ZM13.0854 8H15.9147C15.7088 8.5826 15.1532 9 14.5001 9C13.847 9 13.2914 8.5826 13.0854 8ZM17 10.4003V14.5C17 15.3284 16.3284 16 15.5 16H4.5C3.67157 16 3 15.3284 3 14.5V7.963L9.74649 11.931L9.82751 11.9693C9.96661 12.0205 10.1231 12.0077 10.2535 11.931L12.4837 10.6187C12.1151 10.4733 11.766 10.2894 11.4414 10.0718L10 10.9199L3 6.802V6.5C3 5.67157 3.67157 5 4.5 5H9.02242C9.05337 4.65659 9.11588 4.32228 9.20703 4H4.5C3.11929 4 2 5.11929 2 6.5V14.5C2 15.8807 3.11929 17 4.5 17H15.5C16.8807 17 18 15.8807 18 14.5V9.74284C17.6929 9.99647 17.3578 10.2174 17 10.4003Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.b0966ad069c4f2437493830185ffdd38.svg";
export { ForwardRef as ReactComponent };